import documents from '../data/cases/documentList.json';

export const getAllDocuments = () => {
    return documents['data'];
};